import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { signOutApiCall } from "./authSlice";
import { toast } from "react-toastify";

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_BASE_URL_USERSERVICE}/api/v1/firms`,
  prepareHeaders: (headers, { getState }) => {
    headers.set("Access-Control-Allow-Origin", "*");
    const token = getState()?.auth?.userInfo?.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithAuth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    api.dispatch(signOutApiCall());
    toast.error(`Signed out successfully due to token expiration!`);
  }
  return result;
};

export const getFirmOnboardingFirmTypeApi = createApi({
  reducerPath: "getFirmOnboardingFirmTypeApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
      getFirmTypes: builder.query({
      query:() => "types",
    })
  }),
  reducer: (state = null, action) => {
    return state;
  },
});

export const { useGetFirmTypesQuery } = getFirmOnboardingFirmTypeApi;
